import React, {useState, useRef, useEffect, Fragment} from 'react';
import VisDiv from '../frontend_components/VisDiv'
import { richEditorDoc } from '../gestioneDatabase/Docs'
import RichTextEditor from '../RichTextEditor'
import SaveButton from '../frontend_components/SaveButton'
import { useStateContext } from '../../context/StateContext';
import { ImportExcelButton } from '../../lib/excel';
import { errorAlert, sortByUpdatedAtDate, unique, sortByUpdatedAtDateDesc } from '../../lib/utils';
import TextField from '../TextField';
import { keyId } from '../../lib/utils'
import { v4 as uuidv4 } from 'uuid';
import {FiEdit, FiSave, FiCopy, FiXCircle } from 'react-icons/fi'
import { useCreateReplace } from '../../hooks/mutations';
import PromiseQueue from 'p-queue'
import ManageSchema from '../../components/management/ManageSchema';
import SchemaImport from '../../sanity_ecommerce/schemas/rich-module/richTextLabelValue'
import { successAlert } from '../../lib/utils';
import Divider from '../frontend_components/Divider';
import { useQueryClient } from '@tanstack/react-query';
import FieldDropdown from '../FieldDropdown';
import { addValueForDropdown, removeEmptyProperties, sortByLabel, } from '../../lib/utils'
import TrueFalseToggle from '../TrueFalseToggle';
import SliderRegistriTemplates from '../SliderRegistriTemplates';
import TestButton from '../frontend_components/TestButton';

/**
 * LawsAndDescriptions
 * #offerManagement
 * @param {object} data - props containing customerProducts, laws, nonConformities, templateRegisters, and customer
 * 
 * @return {JSX.Element} - a component that renders a list of laws and descriptions, with filters for template and search
 * 
 */
const LawsAndDescriptions = ({data={}}) => {

    const {customerProducts, laws, nonConformities, templateRegisters, customer} = data
    const queryClient = useQueryClient()
    const[registerTemplateFilter, setRegisterTemplateFilter] = useState()
    const [showEmpty, setShowEmpty]= useState(false)
    const [selectedDoc, setSelectedDoc]= useState()
    const [searchNcValue, setSearchNcValue] = useState("");

    const searchNcRef = useRef();
    const onSearchClick = (e) => {
        e.stopPropagation()
    };
    const onSearchNc = (e) => {
        setSearchNcValue(e.target.value);
    };
    const searchFilter = (x) => {
        //const text = x?.richText?.blocks?.map?.((x)=>x?.text)?.toString()
        //console.log("DOC IN FILTER", x)

        //return  text?.toLowerCase()?.indexOf(searchNcValue.toLowerCase()) >= 0
        const search =  x?.label?.toLowerCase()?.indexOf(searchNcValue.toLowerCase()) >= 0
        if(showEmpty) return search && !x?.law
        return search 
    }
    const templateFilter = (x) => {
        if(registerTemplateFilter) return x?.registers?.some?.((y)=>y?._ref == registerTemplateFilter?._id)
        return x 
    }

    const consoleData = {
        data,
    }

    return (
        <div style={{overflow:"auto", height:"88vh", paddingBottom:"100px"}}>
            <div style = {{display:"flex", flexDirection:"column"}} >
                <div style={{marginBottom:"20px"}}>
                    <h2>
                        ASSEGNA LEGGE & MODIFICA DESCRIZIONE
                    </h2>
                    <TestButton buttonId="qpekqpoiwiquwghd" consoleData={consoleData} message="TEST LEGGE E DESC"/>
                </div>
                <Divider/>
                <div style={{marginBottom:"15px", marginTop:"15px", display:"flex", justifyContent:"center", flexDirection:"column"}}>
                    <VisDiv>
                        <h4>FILTRA PER FAMIGLIA</h4>
                        <div>
                            <SliderRegistriTemplates 
                                registerTemplateFilter={registerTemplateFilter} 
                                setRegisterTemplateFilter={setRegisterTemplateFilter} 
                                templates={ !Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>x?.customer?._ref == customer?._id)} 
                                //setLoading={setLoading}
                            />
                        </div>
                    </VisDiv>
                    <p>VEDI PRODOTTI SENZA LEGGE ASSEGNATA</p>
                    <TrueFalseToggle value={showEmpty} onClick={()=> setShowEmpty(!showEmpty)}/>
                    <p>CERCA PRODOTTI</p>
                    <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
                        <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearchNc} value={searchNcValue} ref={searchNcRef} />
                    </div>  
                </div>
                {customerProducts
                    ?.filter?.(templateFilter)
                    ?.filter?.(searchFilter)
                    ?.sort(sortByLabel)
                    ?.map?.((item, index)=>(
                        <div key={item?._id}>
                            <LawsAndDescriptionPin nonConformities={nonConformities} laws={laws} item={item} customerProducts={customerProducts}/>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default LawsAndDescriptions


/**
 * LawsAndDescriptionPin
 * 
 * @param {object} laws - laws retrieved from SANITY
 * @param {object} item - customer product retrieved from SANITY
 * @param {number} index - index of the customer product in the list
 * @param {array} customerProducts - list of customer products retrieved from SANITY
 * @param {array} nonConformities - list of non conformities retrieved from SANITY
 * 
 * @return {JSX.Element} - a component that renders a pin containing a law and its description
 * 
 */
export const LawsAndDescriptionPin = ({laws, item, index, customerProducts, nonConformities}) => {
      
    const [value, setValue] = useState(item)
    const [law, setLaw] = useState(!Array.isArray(laws) ? undefined : laws?.find?.((x)=>item?.law?._ref == x?._id))
    const queryClient = useQueryClient()
    const [isEditing, setIsEditing] = useState(false)
    const lawProducts = !Array.isArray(customerProducts) ? [] : customerProducts?.filter?.((x)=>x?.law?._ref == item?._id)
    const lawProductsLabels = lawProducts?.map?.((x, index)=>{
        return (
            <p key={index}>{x?.label}</p>)
    })

    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['customerProductsReport'] })
            const previousData = queryClient.getQueryData(['customerProductsReport'])
        
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['customerProductsReport'], (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return {previousData }
        },
        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message)
            errorAlert("Errore, il documento non é stato aggiornato")
        }
        })

    const editorDocDescription = (data) => {
        //console.log("EDITOR DOC", data)
        const newValue = {...value, details: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
        setValue(newValue)
        //setLaws([...filteredArray, newValue])
    }
    const lawDoc = (lawId) => ({_ref: lawId, _key: keyId(), _type:"reference"})

    const editorDocLaw = (data) => {
        //console.log("EDITOR DOC", data)
        const newValue = {...value, law: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
        setValue(newValue)
    }
    const addLabel = (e) => {
        
        const updatedRichText = value?.details?.blocks
        const newValue = {
            ...value, 
/*                 details: {
                ...value?.richText, 
                blocks: updatedRichText?.map?.((x)=>({...x, _key: x?.key}))
                },  */
            //value: e.target.value, 
            label: e.target.value}
        setValue(newValue)
        
    }
    const save = (value) => {
        //setLaws([...filteredArray, value])
        
        const queryDoc = {
            doc: value,
        }
        console.log("SAVE:", queryDoc)
        updateDocument(queryDoc)
        setIsEditing(false)
    }
    const cancel = () => {
        setIsEditing(false)
        setValue(item)
    }
    const setEditingFn = () => {
            setIsEditing(true)
    }
    const pinTestFunction = () => {
        console.log("pin test", "item", item)
    }
    const copyId = () => {
        console.log("pin Data", item)
        navigator.clipboard.writeText(item?._id)
    }
    return (
        <VisDiv style={{border: "1px solid #ccc", borderRadius:"10px", padding: "10px", marginBottom:"10px"}}  key={index} >
            <VisDiv rules={[false]}>
                <button onClick={pinTestFunction}>testPin</button>
            </VisDiv>
            <VisDiv rules={[]} onClick={()=>console.log(item, value)} style={{textAlign:"center", marginBottom: "10px", display:"flex"}}>
                <VisDiv rules={[isEditing]}>
                    <button type='button' className='round-back-button' style={{backgroundColor:"green"}} onClick={()=>save(value)}>
                        <FiSave            
                        size={15}
                        color={"white"}/>
                    </button>
                </VisDiv>
                <VisDiv rules={[isEditing]}>
                    <button type='button' className='round-back-button' style={{backgroundColor:"black", marginLeft:"10px"}} onClick={cancel}>
                        <FiXCircle 
                            fontSize={30}   
                            size={15}
                            color={"white"}
                        />
                    </button>
                </VisDiv>
                <VisDiv style={{marginLeft:"10px"}}>
                    <button type='button' className='round-back-button' style={{backgroundColor:"blue"}} onClick={()=>copyId()}>
                        <FiCopy            
                        size={15}
                        color={"white"}/>
                    </button>
                </VisDiv>
            </VisDiv>
            <h4>TITOLO PRODOTTO</h4>
            <TextField onBlur={setEditingFn} type="text" onChange={(e)=>addLabel(e)} value={value?.label}/>
            <VisDiv style={{display:"flex", padding: "10px"}}>
                <VisDiv rules={[true]} style={{flex:1.5, padding: "10px"}}> 
                    <h4>DESCRIZIONE</h4>
                    <RichTextEditor onBlur={setEditingFn} noFocus={true} existingDoc={item?.details} readOnly={false} editorDoc={editorDocDescription}/>
                </VisDiv>
                <VisDiv rules={[true]} style={{flex:1, padding: "10px"}}>
                    <h4>LEGGE</h4>
                    <FieldDropdown
                        isSearchable="isSearchable"
                        initialValue={{...law, value: law?.label}}
                        placeHolder={"LEGGE"}
                        options={addValueForDropdown(laws)?.sort(sortByLabel)}
                        onChange={(lawValue) => {
                            setLaw(lawValue)
                            const newValue = {
                                ...item, 
                                law: lawDoc(lawValue?._id), 
                            }
                            setValue(newValue)
                            setEditingFn()
                        }
                        }
                    />
                    <RichTextEditor noFocus={true} existingDoc={law?.richText} readOnly={true} editorDoc={editorDocLaw} updateInitialData={true}/> 
                </VisDiv>
            </VisDiv>
            <TrueFalseToggle 
                value={value?.hideNonConformityDescription}
                onClick={()=>{
                    const newDoc = {...value, hideNonConformityDescription: !value?.hideNonConformityDescription}
                    setEditingFn()
                    setValue(newDoc)
                    
                }}
                label={"NASCONDI DESCRIZIONE NON CONFORMITA"} 
                description={"Selezionare questa opzione se si vuole nascondere la descrizione della non conformità da questo prodotto. "}
            />
            <VisDiv rules={[true]}>
                    <h3>NON CONFORMITA' ASSEGNATE AL PRODOTTO</h3>
                    {item?.nonConformities?.map?.((nc, index)=>{
                        const nonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find?.((x)=>x?._id == nc?._ref)
                        return (
                            <div style={{display:"flex", alignItems:"center"}} key={index}>
                                <TestButton consoleData={{nonConformity}} buttonId={"alskmdalskmdaskdm"} message={"TEST NON CONFORMITY"} />
                                <NonConformityOfferDescriptionPin nonConformity={nonConformity}/>
                            </div>
                        )
                    })}
            </VisDiv>
        </VisDiv>
    )
}

/**
 * Component to edit the description of a non conformity offer
 * @param {Object} nonConformity - the non conformity to edit
 * @returns {JSX.Element} - the component
 */
export const NonConformityOfferDescriptionPin = ({nonConformity}) => {
    const [viewDescription, setViewDescription] = useState(false)
    const [value, setValue] = useState(nonConformity)
    const queryClient = useQueryClient()

    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['nonConformities'] })
            const previousData = queryClient.getQueryData(['nonConformities'])
        
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['nonConformities'], (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return {previousData }
        },
        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message)
            errorAlert("Errore, il documento non é stato aggiornato")
        }
        })

    const update = (value) => {
        //setLaws([...filteredArray, value])
        
        const queryDoc = {
            doc: value,
        }
        console.log("SAVE:", queryDoc)
        updateDocument(queryDoc)
    }

    const toggleDescription = () => {
        setViewDescription(!viewDescription)
        console.log("NON CONFORMITY PIN", nonConformity)
    }
    const editorDocNonConformity = (data) => {
        //console.log("EDITOR DOC", data)
        const newValue = {...value, details: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
        setValue(newValue)

    }
    return (
        <div>
            <div onClick={toggleDescription} style={{padding:"2px"}}>
                <p>{nonConformity?.label}</p>
            </div>
            <VisDiv rules={[viewDescription]}>
                <RichTextEditor onBlur={()=>update(value)} noFocus={true} existingDoc={nonConformity?.details} editorDoc={editorDocNonConformity} updateInitialData={true}/> 
            </VisDiv>
        </div>
    )
}

